import { useOrganizationPolicies } from '@/hooks/api/useOrganizationPolicies';
import { DashboardWidgetWrapper } from '@/pages/organization/components/DashboardWidgetWrapper';
import { PolicyCoverageRow } from '@/pages/organization/components/PolicyCoverageRow';
import { useParams } from 'react-router-dom';
import { POLICY_CATEGORIES_META } from '@/components/policylist/constants';
import type { Policy } from '@kirin/api-client/contracts/policies';

interface PolicyCategoryStats {
  title: string;
  description: string;
  enabledCount: number;
  totalCount: number;
}

const createPolicyStates = (
  policiesData: Policy[] = []
): PolicyCategoryStats[] => {
  return Object.entries(POLICY_CATEGORIES_META).map(
    ([categoryKey, meta]): PolicyCategoryStats => {
      const categoryPolicies = policiesData.filter(
        policy => policy.category === categoryKey
      );
      const totalCount = categoryPolicies.length;
      const enabledCount = categoryPolicies.filter(p => p.enabled).length;

      return {
        title: meta.name,
        description: meta.description,
        enabledCount,
        totalCount,
      };
    }
  );
};

export const PoliciesCoverageWidget = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const {
    data: policiesData,
    isLoading,
    isError,
    error,
    refetch,
  } = useOrganizationPolicies(organizationId);

  const policyCategories = createPolicyStates(policiesData || []);

  return (
    <DashboardWidgetWrapper
      className="xl:col-span-4"
      title="Policies Coverage"
      isLoading={isLoading}
      isError={isError || !!error}
      refetch={refetch}
    >
      <div className="max-h-[400px] h-[400px] overflow-hidden w-full">
        {policyCategories.map((policy, index) => (
          <PolicyCoverageRow key={index} {...policy} />
        ))}
      </div>
    </DashboardWidgetWrapper>
  );
};
